let showMoreOffer = () => {
    let contentWrap = document.querySelectorAll('.ranking__details')

    for (let i = 0; i < contentWrap.length; i++) {
        let openBtn = contentWrap[i].querySelectorAll(
            '.ranking-details-expand-button'
        )
        let closeBtn = contentWrap[i].querySelectorAll(
            '.ranking-details-collaps-button'
        )
        let content = contentWrap[i].querySelectorAll('.ranking-details')

        for (let j = 0; j < openBtn.length; j++) {
            openBtn[j].addEventListener('click', () => {
                openBtn[j].style.display = 'none'
                closeBtn[j].style.display = 'block'
                content[j].style.display = 'block'
            })

            closeBtn[j].addEventListener('click', () => {
                openBtn[j].style.display = 'block'
                closeBtn[j].style.display = 'none'
                content[j].style.display = 'none'
            })
        }
    }
}

export default showMoreOffer
